import React from 'react';
import avatarImage from 'assets/img/avatar/default.png';
import Avatar from 'shared/components/avatar/Avatar';

const GoalOverview = ({ image, goal, clientId, client }) => {
  let firstLetters =
    client && client.first_name && client.last_name
      ? `${client.first_name[0].toUpperCase()}${client.last_name[0].toUpperCase()}`
      : '';

  return (
    <div className="goal-overview">
      <Avatar
        src={image || ''}
        width="56"
        height="56"
        name={`“${goal ? goal : "No goal Specified yet"}”`}
        url={`/clients/${clientId}`}
        firstLetters={firstLetters}
      />
    </div>
  );
}

export default GoalOverview;
